import { forIn } from "lodash";
import { EquipmentClass } from "./EquipmentClass";
import type { IrMap } from "./IrMap";

export class EquipmentClassFunctions {
    public static GetEquipmentClasses(): EquipmentClass[] {
        const equipmentClasses: EquipmentClass[] = [];
        forIn(EquipmentClass, (key) => {
            if (typeof key === "number") {
                equipmentClasses.push(key as any as EquipmentClass);
            }
        });
        return equipmentClasses;
    }

    public static GetEquipmentClassDictionary(): IrMap<EquipmentClass, string> {
        return EquipmentClassFunctions.GetEquipmentClasses().map((ec) => ({ key: ec, value: EquipmentClass[ec] }));
    }

    public static EquipmentClassIcon(equipmentClass: EquipmentClass): string {
        switch (equipmentClass) {
            case EquipmentClass.Other:
                return "question-circle";
            case EquipmentClass.Camera:
                return "video";
            case EquipmentClass.IOModule:
                return "bolt";
            case EquipmentClass.Speaker:
                return "bullhorn";
            case EquipmentClass.Microphone:
                return "microphone";
            case EquipmentClass.Siren:
                return "bullhorn";
            case EquipmentClass.Flashlight:
                return "shower";
            case EquipmentClass.Computer:
                return "desktop";
            case EquipmentClass.UPS:
                return "plug";
            case EquipmentClass.ConnectionBox:
                return "server";
            case EquipmentClass.Sign:
                return "map-signs";
            case EquipmentClass.Mount:
                return "long-arrow-up";
            case EquipmentClass.Cable:
                return "link";
            case EquipmentClass.NetworkAppliance:
                return "server";
            case EquipmentClass.InformationMaterial:
                return "file";
            case EquipmentClass.Monitor:
                return "desktop";
            case EquipmentClass.Lighting:
                return "shower";
            case EquipmentClass.ComputerComponent:
                return "server";
            case EquipmentClass.CommunicationComponent:
                return "podcast";
            case EquipmentClass.CameraAccessories:
                return "video-plus";
            case EquipmentClass.CameraExtensionModule:
                return "bolt";
            case EquipmentClass.VideoConverter:
                return "hdd";
            case EquipmentClass.AnalogCamera:
                return "video";
            case EquipmentClass.DummyCamera:
                return "square";
            case EquipmentClass.DummySiren:
                return "square";
            case EquipmentClass.DummySpeaker:
                return "square";
            case EquipmentClass.SimCard:
                return "phone-square";
            case EquipmentClass.Antenna:
                return "podcast";
            case EquipmentClass.GenericOutput:
                return "bullseye";
            case EquipmentClass.DigitalVideoRecorder:
                return "hdd";
            case EquipmentClass.NetworkVideoRecorder:
                return "hdd";
            default:
                return "question-circle";
        }
    }

    public static IconToUnicodeCharacter(icon: string): string {
        const hex = EquipmentClassFunctions.icons[icon];
        if (hex) {
            return hex;
        }

        // eslint-disable-next-line
        console.warn("mmSvgIcon: Icon hex code not found: ", icon);
        return "\f059"; // "question-circle";
    }

    public static showCoveragesForClass(equipmentClass: EquipmentClass): boolean {
        switch (equipmentClass) {
            case EquipmentClass.Camera:
            case EquipmentClass.Lighting:
            case EquipmentClass.AnalogCamera:
                return true;
            default:
                return false;
        }
    }

    private static readonly icons: { readonly [icon: string]: string } = {
        // Get moar from http://fontawesome.io/cheatsheet/
        // or https://github.com/FortAwesome/Font-Awesome/blob/master/less/variables.less
        bolt: "\uf0e7", // I/O
        bullhorn: "\uf0a1", // Siren
        bullseye: "\uf140", // GenericOutput
        "camera-retro": "\uf083", // AnalogCamera
        crosshairs: "\uf05b",
        desktop: "\uf108", // Monitor
        file: "\uf15b", // InformationMaterial
        hdd: "\uf0a0", // Computer
        link: "\uf0c1", // Cable
        "long-arrow-up": "\uf176", // Antenna
        map: "\uf279",
        "map-marker": "\uf041",
        "map-pin": "\uf276",
        "map-signs": "\uf277", // Sign
        microphone: "\uf130",
        "phone-square": "\uf098", // SIM cafd
        plug: "\uf1e6", // UPS
        plus: "\uf067",
        podcast: "\uf2ce", // Antenna
        "question-circle": "\uf059", // Other/unknown
        server: "\uf233",
        shower: "\uf2cc", // IR Light
        signal: "\uf012",
        times: "\uf00d",
        "times-circle": "\uf057",
        video: "\uf03d",
        "volume-down": "\uf027",
        "volume-off": "\uf026",
        "volume-up": "\uf028",
    };
}
